import { Reveal, Eyebrow } from "../components/Reveal";

export const Sizes = ({ sizes }) => {
  return (
    <section id="sizes" className="relative py-28 sm:py-36 bg-[#0E1116] border-y border-white/5" data-testid="sizes-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <Eyebrow>Start with the fit</Eyebrow>
            <h2 className="font-serif-display text-2xl sm:text-3xl lg:text-5xl font-medium tracking-tight text-[#F5F3EF] leading-[1.15]">
              {sizes.length} standard diameters.<br />
              <span className="text-[#A1A8B3]">Height cut to your specification.</span>
            </h2>
          </div>
          <p className="text-sm text-[#A1A8B3] max-w-xs leading-relaxed">
            Every diameter below is the internal capacity of the tube — your product's true fit. Custom diameters available on request.
          </p>
        </Reveal>

        <Reveal delay={0.25}>
          <div className="mt-10 flex flex-wrap gap-2.5" data-testid="size-pills">
            {sizes.map((d) => (
              <a
                key={d}
                href="#quote"
                data-testid={`size-pill-${d}`}
                className="size-pill border border-white/10 rounded-full px-[22px] py-2.5 font-mono-spec text-[15px] text-[#A1A8B3]"
              >
                Ø {d} mm
              </a>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
